(function () {
  'use strict';

  angular.module('dcApp').component('projectElementsSharing', {
    bindings: {
      projectId: '<',
      permissionData: '<',
      onSearchMembers: '&',
    },
    controller: [ProjectElementsSharingController],
    controllerAs: 'vm',
    templateUrl:
      'directives/project/project-elements-sharing/project-elements-sharing.html',
  });

  // --- Controller Function ---
  function ProjectElementsSharingController() {
    var vm = this;

    vm.selectedMember = null;
    vm.searchText = null;
    vm.searchMembers = searchMembers;
    vm.changeMember = changeMember;

    /**
     * Recherche des membres déléguée au parent.
     */
    function searchMembers(query) {
      return vm.onSearchMembers({ query: query });
    }

    /**
     * Rechargement des permissions sur changement de membre sélectionné.
     */
    function changeMember() {
      if (vm.permissionData && vm.permissionData.reload) {
        vm.permissionData.reload();
      }
    }
  }
})();
